/* Nonstop redesign — small behaviours for nsx-* sections. No dependencies. */
(function () {
  function init(root) {
    root = root || document;

    // Flavor filter pills
    root.querySelectorAll('[data-nsx-filter]').forEach(function (group) {
      if (group.dataset.nsxReady) return;
      group.dataset.nsxReady = '1';
      var scope = group.closest('[data-nsx-filter-scope]');
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-filter]');
        if (!btn) return;
        var f = btn.dataset.filter;
        group.querySelectorAll('button[data-filter]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        scope.querySelectorAll('[data-cat]').forEach(function (card) {
          card.hidden = !(f === 'all' || card.dataset.cat === f);
        });
      });
    });

    // Product gallery thumbnails
    root.querySelectorAll('[data-nsx-gallery]').forEach(function (g) {
      if (g.dataset.nsxReady) return;
      g.dataset.nsxReady = '1';
      var main = g.querySelector('[data-nsx-main]');
      g.addEventListener('click', function (e) {
        var t = e.target.closest('button[data-src]');
        if (!t || !main) return;
        main.src = t.dataset.src;
        main.removeAttribute('srcset');
        main.alt = t.dataset.alt || main.alt;
        g.querySelectorAll('button[data-src]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === t ? 'true' : 'false');
        });
      });
    });

    // Quantity steppers
    root.querySelectorAll('[data-nsx-qty]').forEach(function (q) {
      if (q.dataset.nsxReady) return;
      q.dataset.nsxReady = '1';
      var input = q.querySelector('input');
      q.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-step]');
        if (!b) return;
        var v = parseInt(input.value, 10) || 1;
        v = Math.max(1, v + parseInt(b.dataset.step, 10));
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Variant select: keep the price in step with the chosen option
    root.querySelectorAll('[data-nsx-variant]').forEach(function (sel) {
      if (sel.dataset.nsxReady) return;
      sel.dataset.nsxReady = '1';
      var scope = sel.closest('[data-nsx-buy]');
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        scope.querySelectorAll('[data-nsx-price]').forEach(function (el) { el.textContent = opt.dataset.price; });
        scope.querySelectorAll('[data-nsx-unit]').forEach(function (el) { el.textContent = opt.dataset.unit; });
        var btn = scope.querySelector('[data-nsx-submit]');
        if (btn) {
          var avail = opt.dataset.available === 'true';
          btn.disabled = !avail;
          var label = btn.querySelector('[data-nsx-label]');
          if (label) label.textContent = avail ? label.dataset.add : label.dataset.soldout;
        }
      });
    });

    // Sticky add-to-cart: shows once the main button scrolls out of view
    root.querySelectorAll('[data-nsx-sticky]').forEach(function (bar) {
      if (bar.dataset.nsxReady) return;
      bar.dataset.nsxReady = '1';
      var target = document.getElementById(bar.dataset.nsxSticky);
      if (!target || !('IntersectionObserver' in window)) return;
      var footer = document.querySelector('footer, .shopify-section-group-footer-group');
      var mainVisible = true, footerVisible = false;
      function update() { bar.classList.toggle('is-visible', !mainVisible && !footerVisible); }
      new IntersectionObserver(function (en) {
        mainVisible = en[0].isIntersecting || en[0].boundingClientRect.top > 0;
        update();
      }).observe(target);
      if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; update(); }).observe(footer);
    });
  }

  // The header is transparent and sits on top of the page; measure it so the first section clears it.
  function measureHeader() {
    var h = document.querySelector('.section-header');
    if (!h || h.classList.contains('scrolled-past-header')) return;
    var overlay = getComputedStyle(h).position === 'absolute';
    document.documentElement.style.setProperty('--nsx-header-h', (overlay ? h.offsetHeight : 32) + 'px');
  }
  var resizeTimer;
  window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(measureHeader, 150); });
  window.addEventListener('load', measureHeader);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { measureHeader(); init(); });
  else { measureHeader(); init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
